/**
 * BEST PRACTICE VERSION (stops runaway loops + faster + safer)
 *
 * What this does:
 * - Shows up to MAX_SWATCHES available swatches per product (keeps DOM order)
 * - Displays "+N" in .extra-swatchy-{parentHandle}
 * - Uses MutationObserver (debounced) to re-run after AJAX replaces grid HTML
 * - Caches availability results (no refetch storm)
 * - Hard-stops re-entrant runs so it can’t spiral
 *
 * IMPORTANT:
 * - Do NOT hook/monkey-patch window.fetch or XHR (that caused your crash loop).
 */

(function () {
    var MAX_SWATCHES = 4;

    // Prevent overlapping / runaway calls
    var isRunning = false;

    // Debounce init calls (observer + manual)
    var debounceTimer = null;

    // Cache: handle -> boolean (available)
    var availabilityCache = Object.create(null);

    // Track in-flight fetches so we don't duplicate requests
    var inflight = Object.create(null);

    // Expose a safe public method so your click handler can re-run once after replaceWith()
    window.Swatchy = window.Swatchy || {};
    window.Swatchy.refresh = scheduleInit;

    function scheduleInit() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
            buildFabricSwatches();
            initSwatches();
        }, 120);
    }

    function fileImageUrl(filename) {
        if (!filename) return "";
        if (filename.indexOf("http") === 0 || filename.indexOf("//") === 0) return filename;
        return "/cdn/shop/files/" + String(filename).replace(/^\//, "");
    }

    function buildFabricSwatches() {
        var wraps = document.querySelectorAll(".fabric-swatches-wrap:not([data-built])");

        wraps.forEach(function (wrap) {
            var parentHandle = wrap.getAttribute("data-parent-handle");
            var dataEl = wrap.querySelector(".fabric-swatches-data");
            if (!parentHandle || !dataEl) return;

            var fabrics;
            try {
                fabrics = JSON.parse(dataEl.textContent || "[]");
            } catch (e) {
                return;
            }

            if (!Array.isArray(fabrics) || !fabrics.length) return;

            wrap.setAttribute("data-built", "true");
            dataEl.parentNode.removeChild(dataEl);

            var renderMode = wrap.getAttribute("data-render");
            var currentName = "";
            var isLinkMode = renderMode === "links";
            var swatchClass = isLinkMode ? "swatchy swatchy-link" : "swatchy swatchy-clicky";

            fabrics.forEach(function (swatch) {
                if (!swatch || !swatch.handle) return;

                if (parentHandle === swatch.handle && swatch.swatchName) {
                    currentName = swatch.swatchName;
                }

                var isCurrent = parentHandle === swatch.handle;
                var borderColor = isCurrent ? "#252525" : isLinkMode ? "#FFFFFF" : "#DDDDDD";
                var el = document.createElement("div");

                el.className = swatchClass;
                el.setAttribute("data-handle", swatch.handle);
                el.setAttribute("data-parent-handle", parentHandle);
                el.style.borderColor = borderColor;

                var imageStyle =
                    "background-image: url(" +
                    fileImageUrl(swatch.image) +
                    "); background-size: cover; height: 30px; width: 30px; border-radius: 50%; margin: 0; padding: 0;";

                if (isLinkMode) {
                    // Hidden until availability is confirmed (sold-out prints stay hidden)
                    el.style.display = "none";
                    var swatchLabel = swatch.swatchName || swatch.handle || "Print";
                    el.innerHTML =
                        '<a href="/products/' +
                        encodeURIComponent(swatch.handle) +
                        '" aria-label="' +
                        String(swatchLabel).replace(/"/g, "&quot;") +
                        '"><div class="swatch__list--item" style="' +
                        imageStyle +
                        '"></div></a>';
                } else {
                    el.style.display = "none";
                    el.innerHTML =
                        '<div class="load-swatch" style="cursor: pointer;">' +
                        '<div class="swatch__list--item imagey" style="background-image: url(' +
                        fileImageUrl(swatch.image) +
                        ');"></div>' +
                        "</div>";
                }

                wrap.appendChild(el);
            });

            if (currentName) {
                document.querySelectorAll(".fabric-swatches-title[data-parent-handle]").forEach(function (titleEl) {
                    if (titleEl.getAttribute("data-parent-handle") === parentHandle) {
                        titleEl.textContent = "Print: " + currentName;
                    }
                });
            }

            if (!isLinkMode && fabrics.length > MAX_SWATCHES) {
                var extraLink = document.createElement("a");
                extraLink.href = "/products/" + encodeURIComponent(parentHandle);
                extraLink.setAttribute("aria-label", "More prints");
                extraLink.style.display = "none";
                extraLink.innerHTML =
                    '<div class="extra-swatchy-' +
                    parentHandle +
                    ' swatchy extra-swatchy" style="display: none;"></div>';
                wrap.appendChild(extraLink);
            }
        });
    }

    function initSwatches() {
        if (isRunning) return;
        isRunning = true;

        var allSwatches = Array.prototype.slice.call(
            document.querySelectorAll(".swatchy-clicky[data-handle][data-parent-handle], .swatchy-link[data-handle][data-parent-handle]")
        ).filter(function (el) {
            return el.getAttribute("data-handle");
        });

        if (!allSwatches.length) {
            isRunning = false;
            return;
        }

        // Group swatches by parent handle
        var byParent = {};
        allSwatches.forEach(function (el) {
            var parent = el.getAttribute("data-parent-handle");
            if (!parent) return;
            if (!byParent[parent]) byParent[parent] = [];
            byParent[parent].push(el);
        });

        // Hide all "+N" indicators immediately (prevents flicker)
        for (var parent in byParent) {
            var extraEl = document.querySelector(".extra-swatchy-" + cssEscape(parent));
            if (extraEl) extraEl.style.display = "none";
        }

        // Collect unique handles used by swatches
        var handles = [];
        allSwatches.forEach(function (s) {
            var h = s.getAttribute("data-handle");
            if (!h) return;
            if (handles.indexOf(h) === -1) handles.push(h);
        });

        // Determine which handles need fetching (not cached)
        var toFetch = handles.filter(function (h) {
            return availabilityCache[h] === undefined;
        });

        // If everything cached, just apply and exit
        if (!toFetch.length) {
            applySwatches(byParent, availabilityCache);
            isRunning = false;
            return;
        }

        // Fetch missing availability (deduped by inflight)
        var promises = toFetch.map(function (handle) {
            if (inflight[handle]) return inflight[handle];

            inflight[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", {
                credentials: "same-origin",
                cache: "force-cache",
            })
                .then(function (res) {
                    if (!res.ok) throw new Error("Bad response");
                    return res.json();
                })
                .then(function (product) {
                    availabilityCache[handle] = !!(product && product.available);
                })
                .catch(function () {
                    availabilityCache[handle] = false;
                })
                .finally(function () {
                    delete inflight[handle];
                });

            return inflight[handle];
        });

        Promise.all(promises)
            .then(function () {
                applySwatches(byParent, availabilityCache);
            })
            .finally(function () {
                isRunning = false;
            });
    }

    function applySwatches(byParent, availability) {
        for (var parent in byParent) {
            var swatches = byParent[parent];

            // Link-mode swatches (PDP) are not capped at MAX_SWATCHES
            var isLinkMode = swatches[0] && swatches[0].classList.contains("swatchy-link");

            // Hide all first
            for (var i = 0; i < swatches.length; i++) {
                swatches[i].style.display = "none";
            }

            // Keep original DOM order, show only available
            var availableSwatches = [];
            for (var j = 0; j < swatches.length; j++) {
                var el = swatches[j];
                var handle = el.getAttribute("data-handle");
                if (handle && availability[handle]) availableSwatches.push(el);
            }

            // Show first N
            var maxToShow = isLinkMode ? availableSwatches.length : MAX_SWATCHES;
            for (var k = 0; k < Math.min(maxToShow, availableSwatches.length); k++) {
                availableSwatches[k].style.display = "inline-block";
            }

            if (isLinkMode) {
                // Hide the "Print:" title if nothing is left to show
                document.querySelectorAll(".fabric-swatches-title[data-parent-handle]").forEach(function (titleEl) {
                    if (titleEl.getAttribute("data-parent-handle") === parent) {
                        titleEl.style.display = availableSwatches.length ? "" : "none";
                    }
                });
                continue;
            }

            // Update "+N"
            var remaining = Math.max(0, availableSwatches.length - MAX_SWATCHES);
            var extraEl = document.querySelector(".extra-swatchy-" + cssEscape(parent));
            var extraLink = extraEl && extraEl.parentElement && extraEl.parentElement.tagName === "A"
                ? extraEl.parentElement
                : null;

            if (extraEl) {
                if (remaining > 0) {
                    extraEl.textContent = "+" + remaining;
                    extraEl.style.display = "inline-block";
                    if (extraLink) {
                        extraLink.style.display = "";
                        extraLink.setAttribute("aria-label", "More prints, +" + remaining);
                        /* Cloned/offscreen slick slides must not leave focusable links */
                        if (extraLink.closest && extraLink.closest('.slick-slide[aria-hidden="true"]')) {
                            extraLink.setAttribute("tabindex", "-1");
                        } else if (extraLink.getAttribute("tabindex") === "-1") {
                            extraLink.removeAttribute("tabindex");
                        }
                    }
                } else {
                    extraEl.textContent = "";
                    extraEl.style.display = "none";
                    if (extraLink) {
                        extraLink.style.display = "none";
                        extraLink.setAttribute("tabindex", "-1");
                    }
                }
            }
        }
    }

    // MutationObserver to re-run after collection HTML updates (debounced)
    function startObserver() {
        var target =
            document.querySelector(".main-content") ||
            document.querySelector("#MainContent") ||
            document.body;

        if (!target) return;

        var obs = new MutationObserver(function () {
            scheduleInit();
        });

        obs.observe(target, { childList: true, subtree: true });
    }

    // CSS.escape fallback for older browsers
    function cssEscape(str) {
        if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(str);
        // minimal escape: replace spaces and special chars used in selectors
        return String(str).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
    }

    // Boot
    document.addEventListener("DOMContentLoaded", function () {
        buildFabricSwatches();
        initSwatches();
        startObserver();
    });
})();

/**
 * CLICK HANDLER (Shopify / jQuery)
 * - Replaces the product block with the selected variant product HTML
 * - Rebuilds isotope + slick
 * - Calls Swatchy.refresh() ONCE after replacement (no global fetch/XHR hooks needed)
 */
$(document).on("click", ".swatchy-clicky", function () {
    var handle = $(this).data("handle");
    var parentHandle = $(this).data("parent-handle");

    if (!handle || !parentHandle) return;

    var $grid = $(".jas-masonry");

    // Optional: show loader on the old product
    var $oldProduct = $('[data-product-id="' + parentHandle + '"]');
    var $slickSlider = $(".jas-carousel");
    if ($slickSlider.length === 0) {
        $oldProduct.append('<div class="ajax-loader"><div class="spinner"></div></div>');
    }

    $.get("/products/" + encodeURIComponent(handle) + "?view=ajax", function (data) {
        var $data = $(data);

        // Try direct filter, then find
        var $newProduct = $data.filter('[data-product-id="' + handle + '"]');
        if ($newProduct.length === 0) {
            $newProduct = $data.find('[data-product-id="' + handle + '"]');
        }

        if ($newProduct.length === 0) {
            // Fallback: don't replace if we didn't find what we need
            console.warn("Ajax product markup not found for handle:", handle);
            return;
        }

        // Replace the entire product block
        $('[data-product-id="' + parentHandle + '"]').replaceWith($newProduct);

        // Re-init swatches ONCE after DOM replacement
        if (window.Swatchy && typeof window.Swatchy.refresh === "function") {
            window.Swatchy.refresh();
        }

        // Wait for images then rebuild Isotope (guard if plugin not present)
        if ($grid.length && typeof $grid.imagesLoaded === "function") {
            $grid.imagesLoaded(function () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                // Prevent layout jump
                $("body").css({
                    overflow: "hidden",
                    position: "fixed",
                    top: "-" + scrollTop + "px",
                    width: "100%",
                });

                // Destroy existing Isotope instance safely
                if (typeof $grid.isotope === "function") {
                    try {
                        $grid.isotope("destroy");
                    } catch (e) {}
                    $grid.isotope({
                        itemSelector: ".jas-grid-item",
                        layoutMode: "fitRows",
                        masonry: { horizontalOrder: true },
                    });
                }

                $("body").css({ overflow: "", position: "", top: "", width: "" });
                window.scrollTo(0, scrollTop);
            });
        }

        // Re-init Slick safely
        var $slick = $(".jas-carousel");
        if ($slick.length && typeof $slick.slick === "function") {
            try {
                $slick.slick("unslick");
            } catch (e) {}
            $slick.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
            });
        }
    }).fail(function () {
        console.error("Error loading product:", handle);
        $('[data-product-id="' + parentHandle + '"]').append("<p>Error loading product.</p>");
    });
});
